import styled, { css, keyframes } from 'styled-components';
import Spinner1 from 'common/Icon/components/Spinner1';
import { colors } from 'settings';
import { Color } from 'settings/colors';
import { typeScale } from 'settings/typography';

const spinnerSpin = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
`;

type SpinnerSize = 'small' | 'medium' | 'large' | 'default';

const sizeToHeightAndWidth: Record<SpinnerSize, number> = {
    small: typeScale.size2,
    default: typeScale.size3,
    medium: typeScale.size5,
    large: typeScale.size6,
};

export interface SpinnerProps {
    color?: Color;
    inline?: boolean;
    size?: SpinnerSize;
}

const Spinner = styled(Spinner1)<SpinnerProps>`
    animation: ${spinnerSpin} 0.7s infinite linear;
    color: ${({ color = 'fiftyFirstShade' }) => colors[color]};
    display: ${({ inline = false }) => (inline ? 'inline' : 'block')};
    z-index: 10;

    ${({ size = 'default' }) => css`
        height: ${sizeToHeightAndWidth[size]}px;
        width: ${sizeToHeightAndWidth[size]}px;
    `}
`;

export default Spinner;
